export default __webpack_public_path__ + "static/media/t1Sala3.9e889b68.jpg";